import { adminHttpClient } from '../commons/adminHttpClient'

const getBenefitEligibilityDate = (productClassId: string, employeeHireDate: string): Promise<any> => {
  return adminHttpClient.get(`/Benefit/BenefitEligibilityDate`, {
    productClassId,
    employeeHireDate,
  })
}

export default getBenefitEligibilityDate
